import React, { useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import PageNavContainer from '../../../state/PageNavContainer'
import FeedbackThankYouPage from './FeedbackThankYouPage'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `feedback-thank-you`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackThankYouModule = () => {
  const [, setNav] = PageNavContainer.useContainer()
  const loaderData = useLoaderData()

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
    })
  }, [setNav])

  return <FeedbackThankYouPage content={loaderData.page.content} />
}

export default FeedbackThankYouModule
